import { toAgreementStepError } from 'pages/AgreementFlow/utils';

export const generateAgreement = () => ({
  promise: ({ client }) => client.post(`/homeowners/agreements/generate`),
  auth: true,
  redirectToHomeOnHide: true,
});

export const fetchAgreementFlowById = (flowId) => ({
  promise: ({ client }) => client.get(`/homeowners/agreements/${flowId}`),
  auth: true,
  redirectToHomeOnHide: true,
});

// clientMiddleware rejects with the response body alone, so a 400's refusal is told apart here, where the status is known.
export const fetchAgreementFlowStep = (flowId, stepKey, stepId) => ({
  promise: ({ client }) =>
    client
      .get(`/homeowners/agreements/${flowId}/${stepKey}/${stepId}`)
      .catch((error) => {
        throw toAgreementStepError(error);
      }),
  auth: true,
  redirectToHomeOnHide: true,
});

export const updateAgreementFlowStep = (
  flowId,
  stepKey,
  stepId,
  stepData = {},
) => ({
  promise: ({ client }) =>
    client.put(`/homeowners/agreements/${flowId}/${stepKey}/${stepId}`, {
      ...stepData,
    }),
  auth: true,
  redirectToHomeOnHide: true,
});

export const fetchAgreementPdfUrl = (documentId) => ({
  promise: ({ client }) =>
    client.get(`document-instances/${documentId}/download`),
});
